<div class="minor-page-wrapper" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="25px">   
    <div style="background-color: white;" fxFlexFill>
        <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Commodity Positions
        </div>
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="positionsDataSource" matSort #positionsSort="matSort">
                <!-- Trade Date Column -->
                <ng-container matColumnDef="tradeDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.tradeDate | date: 'MM/dd/yyyy' }} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Trans. # Column -->
                <ng-container matColumnDef="tradeNum">
                    <th mat-header-cell *matHeaderCellDef> Trans. # </th>
                    <td mat-cell *matCellDef="let element"> {{element.tradeNum}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Position Type -->
                <ng-container matColumnDef="unitBal">
                    <th mat-header-cell *matHeaderCellDef> Position Type </th>
                    <td mat-cell *matCellDef="let element"> {{element | transactionType}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Units Column -->
                <ng-container matColumnDef="positionType">
                    <th mat-header-cell class="cell-align-right" *matHeaderCellDef> Units </th>
                    <td align="right" mat-cell *matCellDef="let element"> {{element.unitBal}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Description Column -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> {{element.comdyDesc | commodityDescription}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Settled Column -->
                <ng-container matColumnDef="settled">
                    <th mat-header-cell class="cell-align-right" *matHeaderCellDef> Settled </th>
                    <td mat-cell align="right" *matCellDef="let element"> {{element.unitBal}} </td>
                    <td mat-footer-cell class="cell-align-right" *matFooterCellDef> Total Owned </td>
                </ng-container>
                <!-- Original Value Column -->
                <ng-container matColumnDef="origValue">
                    <th mat-header-cell class="cell-align-right" *matHeaderCellDef> Orig. Value </th>
                    <td mat-cell align="right" *matCellDef="let element"> {{element.dolBal | number : '1.2-2'}} </td>
                    <td mat-footer-cell class="cell-align-right" *matFooterCellDef>
                        {{ getTotalOrigVal() | number : '1.2-2'}} </td>
                </ng-container>
                <!-- Market Value Column -->
                <ng-container matColumnDef="extendedMktVal">
                    <th mat-header-cell class="cell-align-right" *matHeaderCellDef> Mkt. Value </th>
                    <td mat-cell align="right" *matCellDef="let element"> {{element.extendedMktVal | number : '1.2-2'}}
                    </td>
                    <td mat-footer-cell class="cell-align-right" *matFooterCellDef>
                        {{ getLongMktVal() | number : '1.2-2'}} </td>
                </ng-container>

                <ng-container matColumnDef="blankCell">
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <ng-container matColumnDef="totalLeasedLabel">
                    <td mat-footer-cell class="cell-align-right" *matFooterCellDef> Total Leased </td>
                </ng-container>
                <ng-container matColumnDef="totalLeasedOrigValLabel">
                    <td mat-footer-cell class="cell-align-right" *matFooterCellDef>
                        {{ getTotalLeasedOrigVal() | number : '1.2-2'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="totalLeasedMktValLabel">
                    <td mat-footer-cell class="cell-align-right" *matFooterCellDef>
                        {{ getLeasedMktVal() | number : '1.2-2'}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="positionsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: positionsColumns;"></tr>
                <tr mat-footer-row *matFooterRowDef="positionsColumns"></tr>
                <tr mat-footer-row
                    *matFooterRowDef="['blankCell', 'blankCell', 'blankCell', 'blankCell', 'blankCell', 'totalLeasedLabel', 'totalLeasedOrigValLabel', 'totalLeasedMktValLabel']">
                </tr>
            </table>
            <mat-paginator #positionsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
    <div style="background-color: white;" fxFlexFill>
        <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Limit And Stop
            Orders</div>
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="stoplimitsDataSource" matSort #stoplimitsSort="matSort">
                <!-- Expiration Date Column -->
                <ng-container matColumnDef="expirationDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiration Date </th>
                    <td mat-cell *matCellDef="let element"> {{ element.goodUntilDate | date: 'MM/dd/yyyy' }} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Trans. # Column -->
                <ng-container matColumnDef="tradeNum">
                    <th mat-header-cell *matHeaderCellDef> Trans. # </th>
                    <td mat-cell *matCellDef="let element"> {{element.tradeNum}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Order Type -->
                <ng-container matColumnDef="orderType">
                    <th mat-header-cell *matHeaderCellDef> Order Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.orderType | stoplimitType}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Units Column -->
                <ng-container matColumnDef="unitBal">
                    <th class="cell-align-right" mat-header-cell *matHeaderCellDef> Units </th>
                    <td class="cell-align-right" mat-cell *matCellDef="let element"> {{element.orgUnits}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Description Column -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> {{element.comdyDesc | commodityDescription}} </td>
                    <td mat-footer-cell *matFooterCellDef> </td>
                </ng-container>
                <!-- Original Value Column -->
                <ng-container matColumnDef="origValue">
                    <th class="cell-align-right" mat-header-cell *matHeaderCellDef> Price </th>
                    <td class="cell-align-right" mat-cell *matCellDef="let element"> {{element.orgPrice | number : '1.2-2'}} </td>
                    <td mat-footer-cell *matFooterCellDef> 0 </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="stoplimitsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: stoplimitsColumns;"></tr>
            </table>
            <mat-paginator #stoplimitsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>